import { createFileRoute } from "@tanstack/react-router";

import { BackofficeDashboardPage } from "@/modules/backoffice/pages/BackofficeDashboardPage";

export const Route = createFileRoute("/__authed/m/dashboard/")({
	component: BackofficeDashboardPage,
});
